// extracted by mini-css-extract-plugin
module.exports = {"formatBytes":"S3_formatBytes__3P5vZ"};